import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1aef3efd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Account name / number:")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "search-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 3,
  class: "account-option account-option-selected"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        ref: "searchInput",
        onKeyup: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateSearchString && _ctx.updateSearchString(...args))),
        class: "search-input"
      }, null, 544),
      _createElementVNode("a", {
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.clearSearch()), ["prevent"])),
        href: "",
        class: "search-clear"
      }, [
        _createElementVNode("img", {
          src: `${_ctx.publicPath}icons/close.svg`,
          alt: "X"
        }, null, 8, _hoisted_4)
      ])
    ]),
    _hoisted_5,
    (_ctx.hasError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, " There was an error retrieving accounts "))
      : _createCommentVNode("", true),
    (_ctx.accountSearchString && !_ctx.accountInfo && !_ctx.selectedAccount && !_ctx.hasError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Loading... "))
      : _createCommentVNode("", true),
    (_ctx.accountInfo && _ctx.accountInfo.accounts && !_ctx.selectedAccount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountInfo.accounts, (account) => {
            return (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (_ctx.selectAccount(account)),
              key: account.accountNumber,
              class: "account-option account-option-unselected"
            }, _toDisplayString(account.contact.Name) + " (" + _toDisplayString(account.accountNumber) + ") ", 9, _hoisted_9))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedAccount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createTextVNode(_toDisplayString(_ctx.selectedAccount.contact.Name) + " (" + _toDisplayString(_ctx.selectedAccount.accountNumber) + ") ", 1),
          _createElementVNode("span", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deselectAccount())),
            class: "deselect-button"
          }, "(x)")
        ]))
      : _createCommentVNode("", true)
  ]))
}